var React = require('react');

function Networking (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#00deb2;}")),React.createElement("title",{"key":1},"Account"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"className":"cls-1","d":"M12.22,13.87A6.94,6.94,0,1,0,5.29,6.93,7,7,0,0,0,12.22,13.87Zm0-11.46A4.53,4.53,0,1,1,7.7,6.93,4.53,4.53,0,0,1,12.22,2.41Z","key":0}),React.createElement("path",{"className":"cls-1","d":"M12.22,18.61a11.07,11.07,0,0,1,7.53,2.94l2.54-.82a13.47,13.47,0,0,0-22,2.71c-.1.19-.18.37-.27.56H2.72A11,11,0,0,1,12.22,18.61Z","key":1})]))]);
}

Networking.defaultProps = {"viewBox":"0 0 22.29 24"};

module.exports = Networking;

Networking.default = Networking;
